import { createSelector, createSlice } from "@reduxjs/toolkit";
import { _layers } from "../../utils/layers";
import { getLayersDescription } from "../actions/map";
import { Terrain } from "../../utils/layer-types";


export const none = 'none';
export const layersPanel = 'layers';
export const info = 'info';

const initialState = {
    selectedPanel: none,
    layers: _layers,
    layerDescriptions: { layers: [] },
    zoomLevel: 1,
    selectedFeature: { visible: false },
    selectedLayer: undefined
}

export const mapSlice = createSlice({
    name: 'map',
    initialState,
    reducers: {
        selectPanel: (state, { payload }) => {
            if (state.selectedPanel === payload)
                state.selectedPanel = none;
            else
                state.selectedPanel = payload;
        },
        changeVisible: (state, { payload }) => {
            let layers = state.layers;            
            let layer = layers.find(l => l.id === payload.id)
            layer.visible = !layer.visible;
            if (layer.visible && layer.type) {
                layer.loading = true;
            }
            let ids = [payload.id];
            while (ids.length) {
                let childs = layers.filter(el => ids.includes(el.parentId));
                childs.forEach(child => {
                    child.visible = layer.visible
                    if (layer.visible && child.type) {
                        child.loading = true;
                    }
                })
                ids = childs.map(child => child.id);
            }
            let parentId = layer.parentId;
            while (parentId) {
                let parent = layers.find(l => l.id === parentId)
                let childs = layers.filter(child => child.parentId === parentId);
                if (childs.every((val, i, arr) => val.visible === arr[0].visible)) {
                    parent.visible = childs[0].visible;
                }
                else {
                    parent.visible = null;
                }
                parentId = parent.parentId;
            }
            state.layers = layers;
        },
        changeOpacity: (state, { payload }) => {
            let layers = state.layers;  
            let layer = layers.find(l => l.id === payload.id)
            layer.opacity = payload.opacity;
            state.layers = layers;
        },
        setLoading: (state, { payload }) => {
            let layers = state.layers;  
            let layer = layers.find(l => l.id === payload.id)
            layer.loading = payload.loading;
            state.layers = layers;
        },
        changeCollaps: (state, { payload }) => {
            let layers = state.layers;  
            let layer = layers.find(l => l.id === payload.id)
            layer.collapsed = !(layer.collapsed ?? true);
            state.layers = layers;
        },
        setSelectedFeature: (state, { payload }) => {            
            let layers = state.layers;  
            if (state.selectedLayer && state.selectedLayer.id !== payload.layer.id) {
                let layer = layers.find(l => l.id === state.selectedLayer.id)
                layer.selected = false;
            }
            let selectedLayer = layers.find(l => l.id === payload.layer.id)
            selectedLayer.selected = true;
            state.selectedFeature = {visible: payload.visible, feature: payload.feature};
            state.selectedLayer = selectedLayer;
            state.layers = layers;
        },
        unSelect: (state) => {
            let layers = state.layers;  
            let layer = layers.find(l => l.id === state.selectedLayer.id)
            layer.selected = false;
            state.selectedFeature = {...state.selectedFeature, visible: false };
            state.layers = layers;
            state.selectedLayer = undefined;
        },
        setZoom: (state, { payload }) => {            
            state.zoomLevel = payload
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getLayersDescription.fulfilled, (state, { payload }) => {
                state.layerDescriptions = payload;
            })
            .addCase(getLayersDescription.rejected, (state, { payload }) => {
                console.log("Error loading layers description " + payload)
                state.layerDescriptions = { layers: [] };
            })
    },
    selectors: {
        getLayers: createSelector(
                state => state.layers,
                (layers) => layers.filter(item => item.parentId === undefined)
            ),
        getChildLayers: createSelector(
                [
                    state => state.layers,
                    (state, parent) => parent
                ],
                (layers, parent) => parent.type === Terrain ? undefined : layers.filter(item => item.parentId === parent.id)
            )
    }
})
export const { selectPanel, changeVisible, changeCollaps, changeOpacity, setLoading, setSelectedFeature, unSelect, setZoom } = mapSlice.actions
export const { getLayers, getChildLayers } = mapSlice.selectors